import React from 'react';
import type { ComponentContentSchema } from '@vibesites/runtime';
import { useContentToken, EditableToken, RichTextContent } from '@vibesites/runtime/react';

export function AccessibilityStatement() {
  const heading = useContentToken('accessibilitystatement.heading');

  return (
    <section className="bg-white py-8 md:py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <EditableToken
          path="accessibilitystatement.heading"
          defaultValue="Accessibility Statement"
          as="h1"
          className="font-heading text-2xl sm:text-3xl font-normal text-[var(--vibe-color-text)] mb-6"
        >
          {heading || 'Accessibility Statement'}
        </EditableToken>
        <RichTextContent
          path="accessibilitystatement.intro"
          label="Intro Paragraph"
          as="div"
          className="font-body text-base leading-relaxed text-[var(--vibe-color-text-muted)] [&_p]:mb-4 [&_a]:text-[var(--vibe-color-primary)] [&_a]:underline"
        />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AccessibilityStatement',
  displayName: 'Accessibility Statement',
  tokens: {
    'accessibilitystatement.heading': {
      label: 'Page Heading',
      type: 'text',
      defaultValue: 'Accessibility Statement',
    },
    'accessibilitystatement.intro': {
      label: 'Intro Paragraph',
      type: 'richtext',
      defaultValue:
        '<p>We are committed to ensuring digital accessibility for people with disabilities. We continually improve the user experience for everyone and apply relevant accessibility standards.</p>',
    },
  },
};

(AccessibilityStatement as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default AccessibilityStatement;
